import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { OpsAppRoutingModule } from './ops-app-routing.module';
import { OpsDashboardComponent } from './ops-dashboard/ops-dashboard.component';
import { GureDashboardComponent } from './gure-dashboard/gure-dashboard.component';
import { InstrumentServiceComponent } from './instrument-service/instrument-service.component';
import { IncidentDetailComponent } from './incident-detail/incident-detail.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { InstrumentListComponent } from './instrument-list/instrument-list.component';
import { InstrumentCategoriesComponent } from './instrument-categories/instrument-categories.component';
import { SensorsComponent } from './sensors/sensors.component';
import { WorklistListComponent } from './worklist-list/worklist-list.component';
import { WorklistComponent } from './worklist/worklist.component';

import { BarcodeScannerLivestreamModule } from 'ngx-barcode-scanner';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { ChartModule } from 'primeng/chart';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ListboxModule } from 'primeng/listbox';
import { PanelModule } from 'primeng/panel';
import { ScrollerModule } from 'primeng/scroller';
import { SkeletonModule } from 'primeng/skeleton';

import { CookieModule, CookieService } from 'ngx-cookie';

import { OpsappService } from '../services/opsapp.service';

import { SafePipe } from '../pipes/safe.pipe';

@NgModule({
  declarations: [
    OpsDashboardComponent,
    GureDashboardComponent,
    InstrumentServiceComponent,
    IncidentDetailComponent,
    IncidentsComponent,
    InstrumentListComponent,
    InstrumentCategoriesComponent,
    SensorsComponent,
    WorklistListComponent,
    WorklistComponent,
    SafePipe
  ],
  imports: [
    CommonModule,
    BarcodeScannerLivestreamModule,
    OpsAppRoutingModule,
    BrowserModule,
    ProgressSpinnerModule,
    ButtonModule,
    RouterModule,
    InputTextModule,
    FormsModule,
    CardModule,
    CalendarModule,
    TableModule,
    DialogModule,
    DropdownModule,
    InputTextareaModule,
    CheckboxModule,
    ChartModule,
    InputNumberModule,
    InputSwitchModule,
    RadioButtonModule,
    ListboxModule,
    PanelModule,
    ScrollerModule,
    SkeletonModule,
    CookieModule.withOptions()
  ],
  providers: [
    OpsappService,
    CookieService
  ]
})
export class OpsAppModule { }
